export const BUNDLE_CAMPAIGN_HEADLINE =
    'Produktvielfalt im Online Shop entdecken, kombinieren \n' + 'und sparen.';
export const BUNDLE_CAMPAIGN_DESCRIPTION =
    'Kombinieren Sie unsere Lösungen und bringen Sie Ihr Recruiting aufs nächste Level.';
export const BUNDLE_CAMPAIGN_LEGAL_TEXT =
    'Gültig bis zum 29.04.2025. Einmal pro Unternehmen einlösbar. Gilt nur für ausgewählte Produkte im karriere.at Online Shop. Nicht gültig für Personaldienstleister und Firmen außerhalb der DACH Region.';
